import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import ActionBar from '@/components/ActionBar';
import { useState } from 'react';
import { SummarySelect } from '../MarketInterpretationTab/index';
import { SkeletonDashboard } from '@/components/loading/Skeleton';
const MarketInterpretation: React.FC<{ totalData: any; loading: boolean }> = ({
  totalData,
  loading
}) => {
  console.log('totalData', totalData);
  console.log('loading', loading);
  const [selectAll, setSelectAll] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const handleSelectAll = (value: boolean) => {
    setSelectAll(value);
    setIsIndeterminate(false);
  };

  if (loading) {
    return (
      <div className="absolute left-0 top-0 z-[111111] flex h-full w-full items-center justify-center">
        <SkeletonDashboard className="absolute left-0 top-0 w-full px-0" />
      </div>
    );
  }

  // const mapvariant = {
  //   policy_environment_analysis: 'lightPurple',
  //   industry_trend_analysis: 'green',
  //   leading_enterprise_analysis: 'lightPurple',
  //   investment_recommendations: 'green'
  // };

  return (
    <>
      <ScrollArea className="scroll-area-block h-full w-full">
        <SummarySelect
          title="政策环境分析"
          conclusion={totalData.policy_environment_analysis}
          selected={true}
          onSelectChange={checked => console.log('政策环境选择:', checked)}
        />

        {/* 消费板块解读 */}
        <SummarySelect
          title="行业趋势分析"
          conclusion={totalData.industry_trend_analysis}
          variant="green"
          selected={true}
          onSelectChange={checked => console.log('行业趋势选择:', checked)}
        />

        {/* 布局时机判断 */}
        <SummarySelect
          title="龙头企业分析"
          conclusion={totalData.leading_enterprise_analysis}
          variant="lightPurple"
          selected={true}
          onSelectChange={checked => console.log('龙头企业选择:', checked)}
        />

        <SummarySelect
          title="投资建议"
          conclusion={totalData.investment_recommendations}
          variant="blue"
          selected={true}
          onSelectChange={checked => console.log('投资建议选择:', checked)}
          className="mb-[50px]"
        />
      </ScrollArea>
      {/* 操作栏 */}
      <ActionBar
        selectAll={selectAll}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
        className="px-0"
      />
    </>
  );
};

export default MarketInterpretation;
